// extracted by mini-css-extract-plugin
export default {"searchInput":"styles_searchInput__lFUhl","typeahead":"styles_typeahead__xCCux"};